import actions from '../../lib/api/actions';

export async function fetchCustomerBySsn({ commit }, payload) {
  try {
    const response = await actions.fetchCustomerBySsn(payload);

    if (response.status === 200) {
      commit('setCurrentCustomer', response.data);
    }
  }
  catch (e) {
    this.handleApiError(e);
  }
}
